import React from "react";
import "./style.scss";

const ProgressBar = ({ step }) => {
  if (step < 3 || step === 6 || step === 11 || step >= 15) return null;

  const getLineFillClass = (index) => {
    if (index === 0) {
      if (step === 3) return "filled-30";
      if (step === 4) return "filled-60";
      if (step >= 5 && step < 7) return "filled-90";
      if (step >= 7) return "filled-100";
    } else if (index === 1) {
      if (step === 8) return "filled-30";
      if (step === 9) return "filled-60";
      if (step === 10) return "filled-90";
      if (step >= 12) return "filled-100";
    } else if (index === 2) {
      if (step === 13) return "filled-50";
      if (step >= 14) return "filled-100";
    }
    return "";
  };

  const isStepComplete = (index) => {
    if (index === 0) return true;
    if (index === 1) return step >= 7;
    if (index === 2) return step >= 12;
    if (index === 3) return step >= 14;
    return false;
  };

  return (
    <div className="wrapper_progressbar">
      <div className="progress-container">
        {[0, 1, 2, 3].map((i) => (
          <React.Fragment key={i}>
            {i !== 0 && (
              <div className={`line ${getLineFillClass(i - 1)}`}></div>
            )}
            <div
              className={`step ${isStepComplete(i) ? "completed" : "upcoming"}`}
            >
              <div className="circle">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M17.2949 7.9707L10.3715 14.8941L7.20419 11.7193"
                    stroke="#FF044F"
                    stroke-width="1.8"
                  />
                </svg>
              </div>
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default ProgressBar;
